module.exports = __webpack_public_path__ + "img/ico_system.4b3378db.svg";